import React, { useState } from 'react';
import { mountOn } from './lib/mount';
import { showToast } from './lib/toast';
import { DocPreviewScreen, apiDocToCommunityCard } from './components/community';

function DocumentPreviewRoot() {
  const el = document.getElementById('document-preview-root');
  if (!el) return null;

  const loggedIn = el.dataset.loggedIn === 'true';
  const documentsCount = parseInt(el.dataset.documentsCount || '0', 10);
  const maxDocuments = el.dataset.maxDocuments ? parseInt(el.dataset.maxDocuments, 10) : null;

  const [doc] = useState(() => {
    try {
      return apiDocToCommunityCard(JSON.parse(el.dataset.doc));
    } catch (err) {
      console.error('Failed to load document preview:', err);
      return null;
    }
  });

  if (!doc) {
    return (
      <div className="library-view">
        <div style={{ textAlign: 'center', padding: 'var(--spacing-09)' }}>
          <h1 className="ty-heading-lg">Preview unavailable</h1>
          <p className="ty-body-md">
            We couldn't load this document. <a href="/">Back to library</a>.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="library-view cpv-active">
      <DocPreviewScreen
        doc={doc}
        isLoggedIn={loggedIn}
        onToast={showToast}
        documentsCount={documentsCount}
        maxDocuments={maxDocuments}
      />
    </div>
  );
}

mountOn('document-preview-root', <DocumentPreviewRoot />);
